/* eslint-disable no-console */
import { Avatar, Box, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import { DateDiff } from '../../../../../../../libs/HelperContent';

const AllViewers = ({ reactedData }) =>
{
	return (
		<Box sx={{ height: 'fit-content', maxHeight: '250px', overflowY: 'auto' }}>
			{reactedData?.map((viewer:any, index:any) => (
				<Grid
					xs={12}
					key={viewer?.createdBy}
					p='var(--pixel8)'
					sx={{
						borderBottom : index !== reactedData.length - 1 ? '1px solid #AEAEAE66' : 'none'
					}}
				>
					<Stack direction='row' spacing={1} alignItems='center'>
						<Avatar
							alt={viewer?.name}
							src={
								viewer?.createdBy
									? `${process.env.REACT_APP_S3_BASE_URL}/profile/${viewer.createdBy}_profile.jpeg`
									: '/images/icons/defaultUser.svg'
							}
							sx={{ width: 30, height: 30 }}
						/>
						<Stack direction='column' sx={{ overflow: 'hidden' }}>
							<Typography
								variant='subtitle2'
								sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
							>
								{viewer?.name}
							</Typography>
							<Typography variant='caption' color='#67727E'>
								{DateDiff(viewer?.createdAt, new Date().valueOf())}
							</Typography>
						</Stack>
					</Stack>
				</Grid>
			))}
		</Box>
	);
};

export default AllViewers;